import React, { useState, useEffect } from 'react'
//Helpers
import {
  getContructionDate,
  getFakeAddress,
  getLocation,
  getStatus,
  getTitle,
} from '@helpers/helper.developments'
import { ElementHTML, getDescription } from '@helpers/helper.rendering'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { RealEstateDataPageComponentData } from 'types'
import { getMinAndMaxPrice } from '@helpers/helper.unities'
import useQueryUnities from '@hooks/useQueryUnities'

const AboutDevelopment_3 = ({
  developmentID,
  global_data,
  titleElement,
  title,
  titleHexa,
  paragraphHexa,
}: { developmentID: string } & RealEstateDataPageComponentData) => {
  const icons = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const API_KEY = global_data.pageConfig.keys.tokko

  const { data: allDevelopmentData, isLoading } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )

  const [half, setHalf] = useState(false)

  useEffect(() => {
    var form = document.getElementById('form-detail-float')
    if (form) {
      setHalf(true)
    }
  }, [])

  const {
    allUnitiesData,
    isLoading: isLoadingUnities,
    isError: isErrorUnities,
  } = useQueryUnities(developmentID, API_KEY)

  return (
    <section
      className={
        'ficha-description c p-y-config dev ' +
        (isLoading ? 'skeleton' : '') +
        (half ? ' half-container-fluid-left' : ' normal-width')
      }
    >
      <Container fluid>
        <Row>
          <Col lg={12}>
            <ElementHTML
              style={{ color: titleHexa || '#1f1f1f' }}
              elementType={titleElement || 'h2'}
              className="element-width"
              children={title || allDevelopmentData?.publication_title}
            />
            <ElementHTML
              elementType={'p'}
              className="element-width"
              style={{ color: paragraphHexa || '#1f1f1f' }}
              children={allDevelopmentData?.description}
            />
          </Col>
          <Col
            className="mt-5 pt-lg-4"
            lg={11}
          >
            <Row>
              <Col lg={4}>
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Desde</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {isLoadingUnities || isErrorUnities
                      ? 'Cargando..'
                      : 'USD ' +
                        Intl.NumberFormat('de-DE').format(getMinAndMaxPrice(allUnitiesData).min)}
                  </p>
                </div>
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Hasta</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {isLoadingUnities || isErrorUnities
                      ? 'Cargando..'
                      : 'USD ' +
                        Intl.NumberFormat('de-DE').format(getMinAndMaxPrice(allUnitiesData).max)}
                  </p>
                </div>
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Entrega</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getContructionDate(allDevelopmentData)}
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Estado</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getStatus(allDevelopmentData)}
                  </p>
                </div>
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Dirección</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {allDevelopmentData?.fake_address}
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Unidades</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {isLoading || isErrorUnities ? 'Cargando...' : allUnitiesData?.length}
                  </p>
                </div>
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Ubicación</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getLocation(allDevelopmentData)}
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutDevelopment_3
